// src/components/Common/LoadingSpinner.tsx
import { Box, CircularProgress } from '@mui/material';

export const LoadingSpinner = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="100vh"
  >
    <CircularProgress />
  </Box>
);

